var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue-dropzone",
    {
      ref: "dropZoneRef",
      attrs: {
        id: "sender",
        awss3: _vm.awss3,
        options: _vm.options,
        "use-custom-slot": true,
      },
      on: {
        "vdropzone-s3-upload-error": _vm.s3UploadError,
        "vdropzone-s3-upload-success": _vm.s3UploadSuccess,
        "vdropzone-removed-file": _vm.fileRemoved,
      },
    },
    [
      _c("div", { staticClass: "after-drop-message" }, [
        _c("p", [
          _vm._v(
            "You may drag-and-drop an image here. File size must be less than " +
              _vm._s(_vm.options.maxFilesize) +
              " MB."
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }